var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.213,
    height: 12.97,
    viewBox: "0 0 16.213 12.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-delete",
    transform: "translate(-1.125 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_87",
    "data-name": "\\u30D1\\u30B9 87",
    d: "M15.156,17.7l2.861-2.86,2.861,2.86.764-.764-2.861-2.86,2.86-2.861-.764-.764-2.86,2.861-2.861-2.86-.764.764,2.861,2.86-2.86,2.861.764.764Z",
    transform: "translate(-6.894 -3.094)",
    fill: "#f39628"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_88",
    "data-name": "\\u30D1\\u30B9 88",
    d: "M16.527,4.5H7.159a.814.814,0,0,0-.588.253L1.125,10.5v.971L6.57,17.217a.814.814,0,0,0,.588.253h9.368a.811.811,0,0,0,.811-.811V5.311A.811.811,0,0,0,16.527,4.5Zm-.27,11.889H7.275L2.206,11.04v-.11L7.275,5.581h8.981Z",
    fill: "#f39628"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon-delete.e5ff48b63d302a61da186a3ba727b953.svg";
export { ForwardRef as ReactComponent };